"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.similarHotelsActions = exports.showSimilarHotels = exports.setSimilarHotels = exports.setActiveHotelById = exports.resetStore = exports.onSearchSimilarHotels = exports.detachActiveHotelById = void 0;
var _reduxActions = require("redux-actions");
var similarHotelsActions = exports.similarHotelsActions = (0, _reduxActions.createActions)({
  setSimilarHotels: function setSimilarHotels(hotels) {
    return hotels;
  },
  showSimilarHotels: function showSimilarHotels() {
    return undefined;
  },
  onSearchSimilarHotels: function onSearchSimilarHotels(queryID) {
    return queryID;
  },
  setActiveHotelById: function setActiveHotelById(hotelID) {
    return hotelID;
  },
  detachActiveHotelById: function detachActiveHotelById(hotelID) {
    return hotelID;
  },
  resetStore: function resetStore() {
    return undefined;
  }
}, {
  prefix: 'OFFER_DETAILS/SIMILAR_HOTELS'
});
var setSimilarHotels = exports.setSimilarHotels = similarHotelsActions.setSimilarHotels,
  showSimilarHotels = exports.showSimilarHotels = similarHotelsActions.showSimilarHotels,
  onSearchSimilarHotels = exports.onSearchSimilarHotels = similarHotelsActions.onSearchSimilarHotels,
  setActiveHotelById = exports.setActiveHotelById = similarHotelsActions.setActiveHotelById,
  detachActiveHotelById = exports.detachActiveHotelById = similarHotelsActions.detachActiveHotelById,
  resetStore = exports.resetStore = similarHotelsActions.resetStore;